// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".81118505eeadee5f55ef8f903805a085282c68f5.chunk.js";
};